<template>
<div>
  <div v-if="layout">
    <div class="form-group">
      <label class="col-sm-3 control-label no-padding-right">{{ textInput }}</label>
      <div class="col-sm-9">
        <input class="col-xs-10 col-sm-8" :type="type" :required="required" :placeholder="textInput" v-model="content" @input="handleInput" :disabled="disabled"/>
      </div>
    </div>
  </div>
  <div v-else>
    <label>{{ textInput }}</label>
    <div>
      <input class="col-xs-10 col-sm-8" :type="type" :required="required" :placeholder="textInput" v-model="content" @input="handleInput" :disabled="disabled"/>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'InputForm',
  props: {
    value: {
      default: '',
      required: true
    },
    textInput: {
      default: '',
      type: String,
      required: true
    },
    required: {
      default: false,
      type: Boolean,
      required: false
    },
    type: {
      default: 'text',
      type: String,
      required: false
    },
    disabled: {
      default: false
    },
    layout: {
      default: true
    }
  },
  data () {
    return {
			content: this.value ? this.value : ''
    }
  },
  watch: {
    value () {
      this.content = this.value
    }
  },
  methods: {
    handleInput () {
      this.$emit('input', this.content)
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>
